import * as React from 'react'

interface InputWithCopyButtonProps {
  value: string
}

function InputWithCopyButton({ value }: InputWithCopyButtonProps) {
  return (
    <div className="input-group mr-3">
      <input type="text" className="ml-2 form-control form-control-sm" readOnly value={value} />
      <div className="input-group-append">
        <button className="btn btn-secondary btn-sm" type="button" onClick={e => navigator.clipboard.writeText(value)}>
          <i className="far fa-copy" />
        </button>
      </div>
    </div>
  )
}

export default InputWithCopyButton
